import {doc} from './docs.js';
import Varz from '../custom/Varz.js';

doc(
    "varz",
    {
    },
    "View and control all variables nested inside patch",
    () => 0,
    {
        inlets: 0
    }
);

export const varz = (object) => {
    new Varz(object);
    return () => {};
};
